import { useListOrdersWithIssuesQuery } from './threads.api';

// Tab title for the v1 Dashboard's "Probleme" tab (orders with open tickets —
// Order.issues is ticket-maintained now; the tab KEEPS its historical name per
// the user's ask, even though the content is tickets). Reads the count off the
// shared RTK Query cache so it dedupes with the OrdersWithIssues widget fetch.
export function ProblemsTabLabel() {
    const { data } = useListOrdersWithIssuesQuery(
        { page: 1, limit: 10 },
        { pollingInterval: 60000 },
    );

    const count = data?.pagination.totalCount ?? 0;

    return (
        <span>
            Probleme
            {count > 0 && (
                <span className="ml-1.5 inline-flex items-center rounded-full bg-red-100 px-1.5 py-0.5 text-xs font-semibold text-red-800 dark:bg-red-900/40 dark:text-red-300">
                    {count}
                </span>
            )}
        </span>
    );
}
